import React, { useEffect, useState } from "react";
import ApiClient from "../../methods/api/apiClient";
import { useHistory } from "react-router-dom";
import { Tag, Tooltip, Modal, Checkbox } from "antd";
import { toast } from "react-toastify";
import loader from "../../methods/loader";
import Pagination from "react-pagination-js";
import { useSelector } from "react-redux";
import Layout2 from "../../components/global/layout2";
import environment from "../../environment";

const InsuranceReview = () => {
  const [data, setData] = useState([]);
  const history = useHistory();
  const [total, setTotal] = useState(0);
  const [loaderr, setLoaderr] = useState(false);
  const [reviewModal, setReviewModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const [checklist, setChecklist] = useState({
    free_email_blocked: false,
    agency_matches_coi: false,
    fmcsa_match: false,
    naic_verified: false,
    coverage_meets_minimums: false,
    vin_verified: false,
  });

  const user = useSelector((state) => state.user);

  const [filters, setFilter] = useState({
    page: 1,
    count: 20,
    search: "",
    status: "",
  });

  const ChangeFilter = (e) => {
    setFilter(e);
    getData(e);
  };

  const pageChange = (e) => {
    setFilter({ ...filters, page: e });
    getData({ page: e });
  };

  const getData = (p = {}) => {
    loader(true);
    setLoaderr(true);
    var filter = { ...filters, ...p };
    var params = {};
    Object.keys(filter).forEach(function (key) {
      if (filter[key] !== "" && filter[key] !== undefined) {
        params[key] = filter[key];
      }
    });
    ApiClient.get("admin/insurance/pending", params).then((res) => {
      if (res.success) {
        setData(res?.data?.data || res?.data || []);
        setTotal(res?.data?.total_count || res?.data?.total || 0);
      }
      loader(false);
      setLoaderr(false);
    });
  };

  useEffect(() => {
    getData();
  }, []);

  const handleSearch = (e) => {
    var val = e.target.value;
    setFilter({ ...filters, search: val, page: 1 });
    clearTimeout(window._insSearchTimeout);
    window._insSearchTimeout = setTimeout(function () {
      getData({ search: val, page: 1 });
    }, 400);
  };

  const openReview = (item) => {
    setSelectedItem(item);
    var ins = item.insurance || item;
    setChecklist({
      free_email_blocked: ins.free_email_blocked || false,
      agency_matches_coi: false,
      fmcsa_match: ins.fmcsa_match || false,
      naic_verified: ins.naic_valid || false,
      coverage_meets_minimums: ins.coverage_meets_minimums || false,
      vin_verified: ins.vin_verified || false,
    });
    setReviewModal(true);
  };

  var formatDate = function (dateStr) {
    if (!dateStr) return "-";
    var d = new Date(dateStr);
    return d.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  var getStatusTag = function (status) {
    var colors = {
      pending: "processing",
      submitted: "processing",
      verified: "success",
      rejected: "error",
    };
    return (
      <Tag color={colors[status] || "default"}>
        {status || "Pending"}
      </Tag>
    );
  };

  var handleVerdict = function (verdict) {
    if (!selectedItem) return;
    var itemId = selectedItem.id || selectedItem._id || selectedItem.carrier_id;
    loader(true);
    ApiClient.put("admin/insurance/" + itemId + "/verify", {
      status: verdict,
      checklist: checklist,
    }).then((res) => {
      if (res.success) {
        toast.success("Insurance " + verdict + " successfully");
        setReviewModal(false);
        setSelectedItem(null);
        getData();
      }
      loader(false);
    });
  };

  var insData = selectedItem ? (selectedItem.insurance || selectedItem) : {};

  return (
    <Layout2 title="Insurance Review" Sidetitle="Insurance Review">
      <div className="mainareas new-table-set">
        {/* Header */}
        <div className="d-flex flex-wrap justify-content-between align-items-center mb-3">
          <div className="bids-top mb-2 mb-sm-0">
            <h4>
              Insurance Verifications<span>{total}</span>
            </h4>
          </div>
        </div>

        {/* Filters */}
        <div className="d-flex flex-wrap gap-3 mb-3">
          <div style={{ minWidth: "220px", flex: 1, maxWidth: "350px" }}>
            <input
              type="text"
              className="form-control"
              placeholder="Search by carrier name or MC#..."
              value={filters.search}
              onChange={handleSearch}
            />
          </div>
          <div>
            <select
              className="form-control"
              value={filters.status}
              onChange={function (e) {
                var val = e.target.value;
                setFilter({ ...filters, status: val, page: 1 });
                getData({ status: val, page: 1 });
              }}
            >
              <option value="">All Statuses</option>
              <option value="pending">Pending</option>
              <option value="submitted">Submitted</option>
              <option value="verified">Verified</option>
              <option value="rejected">Rejected</option>
            </select>
          </div>
        </div>

        {/* Table */}
        <div className="table-responsive table_section new-table">
          <table className="table">
            <thead>
              <tr>
                <th scope="col">Carrier</th>
                <th scope="col">Agent</th>
                <th scope="col">Agency</th>
                <th scope="col">Submitted</th>
                <th scope="col">Status</th>
                <th scope="col">Coverage</th>
                <th scope="col">Cert Holder</th>
                <th scope="col">FMCSA Match</th>
                <th scope="col">Actions</th>
              </tr>
            </thead>
            <tbody>
              {data?.map(function (itm, index) {
                var ins = itm.insurance || itm;
                return (
                  <tr key={itm.id || itm._id || index}>
                    <td>
                      <div className="user_detail">
                        <div className="user_name">
                          <h4 className="user" style={{ cursor: "pointer" }} onClick={function () { history.push("/carrier-dossier/" + (itm.carrier_id || itm.id || itm._id)); }}>
                            {itm.company_name || itm.carrier_name || "-"}
                          </h4>
                          <span style={{ fontSize: "11px", color: "#888" }}>
                            {itm.mc_number ? "MC#" + itm.mc_number : ""}
                          </span>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div>{ins.agent_name || "-"}</div>
                      <div style={{ fontSize: "11px", color: "#888" }}>{ins.agent_email || ""}</div>
                    </td>
                    <td>{ins.agency_name || "-"}</td>
                    <td>{formatDate(ins.submitted_at || itm.createdAt)}</td>
                    <td>{getStatusTag(ins.status || itm.insurance_status)}</td>
                    <td>
                      <span style={{ fontSize: "12px" }}>
                        {ins.auto_liability_amount ? "Auto: $" + Number(ins.auto_liability_amount).toLocaleString() : ""}
                        {ins.auto_liability_amount && ins.cargo_amount ? " | " : ""}
                        {ins.cargo_amount ? "Cargo: $" + Number(ins.cargo_amount).toLocaleString() : ""}
                        {!ins.auto_liability_amount && !ins.cargo_amount ? "-" : ""}
                      </span>
                    </td>
                    <td>
                      {ins.cert_holder ? (
                        <span style={{ color: "#27ae60" }}>&#10003;</span>
                      ) : (
                        <span style={{ color: "#e74c3c" }}>&#10007;</span>
                      )}
                    </td>
                    <td>
                      {ins.fmcsa_match === true ? (
                        <span style={{ color: "#27ae60" }}>&#10003;</span>
                      ) : ins.fmcsa_match === false ? (
                        <span style={{ color: "#e74c3c" }}>&#10007;</span>
                      ) : (
                        <span style={{ color: "#999" }}>-</span>
                      )}
                    </td>
                    <td>
                      <div className="action_icons">
                        <Tooltip placement="top" title="Review">
                          <span
                            className="edit_icon pointer"
                            onClick={function () { openReview(itm); }}
                          >
                            <i className="material-icons pointer edit">visibility</i>
                          </span>
                        </Tooltip>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        {/* Empty State */}
        {total === 0 && !loaderr ? (
          <div className="no-data">
            <img src="assets/img/no-data.png" alt="No data" />
            No Insurance Reviews Found
          </div>
        ) : null}

        {/* Pagination */}
        {total > 0 ? (
          <div className="paginationWrapper gap-0">
            <div className="d-flex align-items-center mb-2 mb-sm-0">
              <div className="me-2 user-name-color">Show</div>
              {total > 0 && (
                <div className="dropdown addDropdown chnagesname">
                  <button
                    className="btn btn-primary dropdown-toggle removeBg"
                    type="button"
                    id="dropdownMenuButton"
                    data-bs-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    {filters?.count}
                  </button>
                  <div
                    className="dropdown-menu shadow bg_hover"
                    aria-labelledby="dropdownMenuButton"
                  >
                    {[10, 20, 30, 50].map(function (n) {
                      return (
                        <a
                          key={n}
                          className="dropdown-item"
                          onClick={function () { ChangeFilter({ ...filters, count: n, page: 1 }); }}
                        >
                          {n}
                        </a>
                      );
                    })}
                  </div>
                </div>
              )}
              <div className="ms-2 user-name-color">
                from {total} Reviews
              </div>
            </div>
            <Pagination
              currentPage={filters.page}
              totalSize={total}
              sizePerPage={filters.count}
              changeCurrentPage={pageChange}
            />
          </div>
        ) : null}

        {/* Review Modal */}
        <Modal
          title="Insurance Review Details"
          open={reviewModal}
          onCancel={function () { setReviewModal(false); setSelectedItem(null); }}
          width={700}
          footer={null}
        >
          {selectedItem && (
            <div>
              <div className="row mb-3">
                <div className="col-md-6">
                  <h6 style={{ fontWeight: 600, fontSize: "14px" }}>Carrier Information</h6>
                  <p style={{ fontSize: "13px", margin: "4px 0" }}>
                    <strong>Company:</strong> {selectedItem.company_name || selectedItem.carrier_name || "-"}
                  </p>
                  <p style={{ fontSize: "13px", margin: "4px 0" }}>
                    <strong>MC#:</strong> {selectedItem.mc_number || "-"}
                  </p>
                </div>
                <div className="col-md-6">
                  <h6 style={{ fontWeight: 600, fontSize: "14px" }}>Agent Information</h6>
                  <p style={{ fontSize: "13px", margin: "4px 0" }}>
                    <strong>Agent:</strong> {insData.agent_name || "-"}
                  </p>
                  <p style={{ fontSize: "13px", margin: "4px 0" }}>
                    <strong>Email:</strong> {insData.agent_email || "-"}
                  </p>
                  <p style={{ fontSize: "13px", margin: "4px 0" }}>
                    <strong>Agency:</strong> {insData.agency_name || "-"}
                  </p>
                </div>
              </div>

              {insData.coi_url && (
                <div className="mb-3">
                  <a
                    href={insData.coi_url.startsWith("http") ? insData.coi_url : environment.api + "documents/" + insData.coi_url}
                    target="_blank"
                    rel="noreferrer"
                    className="btn btn-outline-primary btn-sm"
                  >
                    <i className="fa fa-file-pdf-o me-1"></i> View COI Document
                  </a>
                </div>
              )}

              <div style={{ borderTop: "1px solid #eee", paddingTop: "16px", marginTop: "8px" }}>
                <h6 style={{ fontWeight: 600, fontSize: "14px", marginBottom: "12px" }}>
                  4-Layer Verification Checklist
                </h6>
                <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                  <Checkbox
                    checked={checklist.free_email_blocked}
                    onChange={function (e) { setChecklist({ ...checklist, free_email_blocked: e.target.checked }); }}
                  >
                    Free email blocked
                  </Checkbox>
                  <Checkbox
                    checked={checklist.agency_matches_coi}
                    onChange={function (e) { setChecklist({ ...checklist, agency_matches_coi: e.target.checked }); }}
                  >
                    Agency info matches COI producer section (manual check)
                  </Checkbox>
                  <Checkbox
                    checked={checklist.fmcsa_match}
                    onChange={function (e) { setChecklist({ ...checklist, fmcsa_match: e.target.checked }); }}
                  >
                    FMCSA insurer match (auto-checked)
                  </Checkbox>
                  <Checkbox
                    checked={checklist.naic_verified}
                    onChange={function (e) { setChecklist({ ...checklist, naic_verified: e.target.checked }); }}
                  >
                    NAIC verified (auto-checked)
                  </Checkbox>
                  <Checkbox
                    checked={checklist.coverage_meets_minimums}
                    onChange={function (e) { setChecklist({ ...checklist, coverage_meets_minimums: e.target.checked }); }}
                  >
                    Coverage meets minimums (auto-checked)
                  </Checkbox>
                  <Checkbox
                    checked={checklist.vin_verified}
                    onChange={function (e) { setChecklist({ ...checklist, vin_verified: e.target.checked }); }}
                  >
                    VIN verification (if scheduled auto)
                  </Checkbox>
                </div>
              </div>

              <div style={{ borderTop: "1px solid #eee", paddingTop: "16px", marginTop: "16px", display: "flex", gap: "8px", justifyContent: "flex-end" }}>
                <button
                  className="btn btn-sm"
                  style={{ backgroundColor: "#27ae60", color: "#fff" }}
                  onClick={function () { handleVerdict("verified"); }}
                >
                  <i className="fa fa-check me-1"></i> Verify
                </button>
                <button
                  className="btn btn-sm"
                  style={{ backgroundColor: "#e74c3c", color: "#fff" }}
                  onClick={function () { handleVerdict("rejected"); }}
                >
                  <i className="fa fa-times me-1"></i> Reject
                </button>
                <button
                  className="btn btn-sm btn-outline-secondary"
                  onClick={function () {
                    var itemId = selectedItem.id || selectedItem._id || selectedItem.carrier_id;
                    loader(true);
                    ApiClient.put("admin/insurance/" + itemId + "/request-resubmit", {}).then(function (res) {
                      if (res.success) {
                        toast.success("Resubmit request sent");
                        setReviewModal(false);
                        getData();
                      }
                      loader(false);
                    });
                  }}
                >
                  <i className="fa fa-refresh me-1"></i> Request Resubmit
                </button>
              </div>
            </div>
          )}
        </Modal>
      </div>
    </Layout2>
  );
};

export default InsuranceReview;
